import { type MouseEvent, useEffect, useState } from "react";

/** `beside` puts a second picture next to `src`: the scan photo next to a catalog picture. */
export function Lightbox({
  src,
  alt,
  beside,
  onClose,
}: {
  src: string;
  alt?: string;
  beside?: string;
  onClose: () => void;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: a backdrop, closed by click or Escape
    <div className="lightbox" onClick={onClose} onKeyDown={(e) => e.key === "Escape" && onClose()}>
      {beside && <img src={beside} alt="scan" />}
      <img src={src} alt={alt ?? ""} />
    </div>
  );
}

/** An image that opens `full` (or itself) over the page when clicked. */
export function ZoomImage({
  src,
  full,
  beside,
  alt,
  className,
  loading,
}: {
  src: string;
  full?: string;
  /** Shown next to the zoomed picture, for comparing. */
  beside?: string;
  alt?: string;
  className?: string;
  loading?: "lazy" | "eager";
}) {
  const [open, setOpen] = useState(false);
  const onClick = (e: MouseEvent) => {
    // Inside a <label> or a <button>, zooming must not also select or pick.
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  };
  return (
    <>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: zoom is a pointer convenience on a picture */}
      <img src={src} alt={alt ?? ""} className={className} loading={loading} onClick={onClick} />
      {open && <Lightbox src={full ?? src} alt={alt} beside={beside} onClose={() => setOpen(false)} />}
    </>
  );
}
